// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlRadar from "../player/PlRadar.bs.js";
import * as PlStats from "./PlStats.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as PlLpChart from "./lp-chart/PlLpChart.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as PlPlacesDistribution from "./PlPlacesDistribution.bs.js";
import Tooltip from "@mui/material/Tooltip";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

function PlStatsTab$MostPlayed(Props) {
  var matches = Props.matches;
  var set = TftSet.use(undefined);
  var unitFreqs = Belt_MutableMapString.make(undefined);
  var traitFreqs = Belt_MutableMapString.make(undefined);
  var itemFreqs = Belt_MutableMapString.make(undefined);
  Belt_Array.forEach(matches, (function (p) {
          return Belt_Array.forEach(p.info.units, (function (unit) {
                        var group = Belt_MutableMapString.getWithDefault(unitFreqs, unit.id, []);
                        group.push(unit.items2.length);
                        Belt_MutableMapString.set(unitFreqs, unit.id, group);
                        Belt_Array.forEach(unit.items2, (function (i) {
                                var curr = Belt_MutableMapString.getWithDefault(itemFreqs, i, 0);
                                return Belt_MutableMapString.set(itemFreqs, i, curr + 1 | 0);
                              }));
                        var traits = Belt_Array.keepMap(p.info.traits, (function (t) {
                                if (t.currentTier > 0) {
                                  return [
                                          t.name,
                                          t.currentTier
                                        ];
                                }
                                
                              }));
                        return Belt_Array.forEach(traits, (function (param) {
                                      var traitId = param[0] + "-" + String(param[1]);
                                      var group = Belt_MutableMapString.getWithDefault(traitFreqs, traitId, []);
                                      group.push(p.info.placement);
                                      return Belt_MutableMapString.set(traitFreqs, traitId, group);
                                    }));
                      }));
        }));
  var unitGroups = Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(unitFreqs), (function (param, param$1) {
          var p2 = param$1[1];
          var u2 = param$1[0];
          var p1 = param[1];
          var u1 = param[0];
          var match = -Caml.caml_int_compare(p1.length, p2.length) | 0;
          switch (match) {
            case -1 :
                return -1;
            case 0 :
                break;
            case 1 :
                return 1;
            default:
              
          }
          var match$1 = -Caml.caml_int_compare(Belt_Array.reduce(p1, 0, (function (acc, v) {
                      return acc + v | 0;
                    })), Belt_Array.reduce(p2, 0, (function (acc, v) {
                      return acc + v | 0;
                    }))) | 0;
          switch (match$1) {
            case -1 :
                return -1;
            case 0 :
                return -Caml.caml_int_compare(Sd.unitTier(u1), Sd.unitTier(u2)) | 0;
            case 1 :
                return 1;
            default:
              return -Caml.caml_int_compare(Sd.unitTier(u1), Sd.unitTier(u2)) | 0;
          }
        }));
  var traitGroups = Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_MutableMapString.toArray(traitFreqs), (function (param) {
              var k = param[0];
              if (!k.includes("Mercenary") && !k.includes("Starship")) {
                return !k.includes("Paragon");
              } else {
                return false;
              }
            })), (function (param, param$1) {
          var match = -Caml.caml_int_compare(param[1].length, param$1[1].length) | 0;
          switch (match) {
            case -1 :
                return -1;
            case 0 :
                break;
            case 1 :
                return 1;
            default:
              
          }
          var r1 = Belt_Int.fromString(Belt_Array.getExn(param[0].split("-"), 1));
          var r2 = Belt_Int.fromString(Belt_Array.getExn(param$1[0].split("-"), 1));
          return -Caml_obj.caml_compare(r1, r2) | 0;
        }));
  var itemGroups = Belt_Array.map(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(itemFreqs), (function (param, param$1) {
              return Caml.caml_int_compare(param$1[1], param[1]);
            })), (function (prim) {
          return prim[0];
        }));
  var allUnits = Sd.allUnits3(set);
  return React.createElement("div", {
              className: "font-montserrat"
            }, React.createElement("div", {
                  className: "leading-tight text-xl font-semibold"
                }, "Most played"), React.createElement("div", {
                  className: "flex gap-2 pt-3"
                }, Belt_Array.map(Belt_Array.slice(Belt_Array.keep(unitGroups, (function (param) {
                                return allUnits.includes(param[0]);
                              })), 0, 7), (function (param) {
                        var u1 = param[0];
                        return React.createElement(UnitTooltip.make, {
                                    unit: u1,
                                    children: React.createElement(UnitImage.make, {
                                          unitId: u1,
                                          size: 36
                                        }),
                                    key: u1
                                  });
                      }))), React.createElement("div", {
                  className: "flex gap-2 items-center pt-[10px]"
                }, Belt_Array.map(Belt_Array.slice(Belt_Array.keep(traitGroups, (function (param) {
                                var s = param[0].split("-");
                                var trait = Belt_Array.getExn(s, 0);
                                var rank = Belt_Option.getExn(Belt_Int.fromString(Belt_Array.getExn(s, 1)));
                                if (Sd.traitStyle(trait, rank, set) > 1) {
                                  return !Sd.isTraitUnique(trait, set);
                                } else {
                                  return false;
                                }
                              })), 0, 4), (function (param) {
                        var k = param[0];
                        var s = k.split("-");
                        var trait = Belt_Array.getExn(s, 0);
                        var rank = Belt_Option.getExn(Belt_Int.fromString(Belt_Array.getExn(s, 1)));
                        return React.createElement(TraitTooltip.make, {
                                    trait: trait,
                                    rank: rank,
                                    children: React.createElement(TraitImage.PlainIcon2.make, {
                                          traitId: trait,
                                          rank: rank,
                                          size: 36
                                        }),
                                    key: k
                                  });
                      })), Belt_Array.map(Belt_Array.slice(Belt_Array.keep(itemGroups, (function (itemId) {
                                return Belt_Option.isSome(Data.itemInfo(itemId, set));
                              })), 0, 3), (function (itemId) {
                        return React.createElement(ItemTooltip.make, {
                                    itemId: itemId,
                                    children: React.createElement(ItemImage.make, {
                                          itemId: itemId,
                                          size: 34,
                                          className: "mx-[1px]",
                                          rounded: "rounded"
                                        }),
                                    key: itemId
                                  });
                      }))));
}

var MostPlayed = {
  make: PlStatsTab$MostPlayed
};

function PlStatsTab(Props) {
  var filter = Props.filter;
  var matches = Props.matches;
  var player = Props.player;
  var onShowDetails = Props.onShowDetails;
  var onShowPlayerRadarInfo = Props.onShowPlayerRadarInfo;
  var masterRanks = Props.masterRanks;
  var forceTimeChart = Props.forceTimeChart;
  var screenSize = ScreenAtom.use(undefined);
  var match = screenSize >= 2 ? (
      screenSize >= 5 ? [
          318,
          150
        ] : [
          588,
          220
        ]
    ) : [
      644,
      240
    ];
  var chartHeight = match[1];
  var chartWidth = match[0];
  var barArea = screenSize >= 5 ? 31 : 28;
  var flexRatings = Belt_Array.keepMap(matches, (function (hp) {
          return Belt_Option.map(hp.ratings, (function (r) {
                        return r.contestedRatio3;
                      }));
        }));
  var flexibility = 1 - Belt_Array.reduce(flexRatings, 0, (function (acc, v) {
          return acc + v;
        })) / Global.f(flexRatings.length);
  var match$1 = filter.typ;
  var tmp;
  var exit = 0;
  switch (match$1) {
    case /* All */0 :
    case /* Ranked */1 :
        exit = 1;
        break;
    case /* Normal */2 :
        tmp = React.createElement("div", {
              className: "pb-4 md:pb-5"
            }, React.createElement(PlLpChart.Placeholder.make, {
                  chartWidth: chartWidth,
                  chartHeight: chartHeight
                }));
        break;
    case /* Hyperroll */3 :
        tmp = player.hrRankHistory.length >= 5 ? React.createElement("div", {
                className: "pb-4 md:pb-5"
              }, React.createElement(PlLpChart.make, {
                    masterRanks: undefined,
                    region: Region.fromApiName(player.playerInfo.region),
                    matches: matches,
                    onShowDetails: onShowDetails,
                    chartWidth: chartWidth,
                    chartHeight: chartHeight,
                    queueId: 1130,
                    rankHistory: player.hrRankHistory,
                    forceTimeChart: forceTimeChart
                  })) : React.createElement("div", {
                className: "pb-4 md:pb-5"
              }, React.createElement(PlLpChart.Placeholder.make, {
                    chartWidth: chartWidth,
                    chartHeight: chartHeight
                  }));
        break;
    case /* Duo */4 :
        var matches$1 = Belt_Array.keep(matches, (function (hp) {
                return hp.queueId === 1160;
              }));
        var raCount = Belt_Array.keepMap(Belt_Array.keep(matches$1, (function (hp) {
                    return hp.queueId === 1160;
                  })), (function (hp) {
                return hp.rankAfter;
              })).length;
        tmp = raCount >= 2 ? React.createElement("div", {
                className: "pb-4 md:pb-5"
              }, React.createElement(PlLpChart.make, {
                    masterRanks: undefined,
                    region: Region.fromApiName(player.playerInfo.region),
                    matches: matches$1,
                    onShowDetails: onShowDetails,
                    chartWidth: chartWidth,
                    chartHeight: chartHeight,
                    queueId: 1160,
                    rankHistory: player.duoRankHistory,
                    forceTimeChart: forceTimeChart
                  })) : React.createElement("div", {
                className: "pb-4 md:pb-5"
              }, React.createElement(PlLpChart.Placeholder.make, {
                    chartWidth: chartWidth,
                    chartHeight: chartHeight
                  }));
        break;
    
  }
  if (exit === 1) {
    var matches$2 = Belt_Array.keep(matches, (function (hp) {
            return hp.queueId === 1100;
          }));
    var raCount$1 = Belt_Array.keepMap(Belt_Array.keep(matches$2, (function (hp) {
                return hp.queueId === 1100;
              })), (function (hp) {
            return hp.rankAfter;
          })).length;
    tmp = raCount$1 >= 2 ? React.createElement("div", {
            className: "pb-4 md:pb-5"
          }, React.createElement(PlLpChart.make, {
                masterRanks: masterRanks,
                region: Region.fromApiName(player.playerInfo.region),
                matches: matches$2,
                onShowDetails: onShowDetails,
                chartWidth: chartWidth,
                chartHeight: chartHeight,
                queueId: 1100,
                rankHistory: player.rankHistory,
                forceTimeChart: forceTimeChart
              })) : React.createElement("div", {
            className: "pb-2 md:pb-3"
          }, React.createElement(PlLpChart.Placeholder.make, {
                chartWidth: chartWidth,
                chartHeight: chartHeight
              }));
  }
  return React.createElement("div", {
              className: "flex flex-col items-center px-3 sm:px-4 py-4"
            }, tmp, React.createElement("div", {
                  className: "flex-col sm:flex-row justify-around " + (
                    matches.length === 0 ? "hidden" : "flex"
                  )
                }, React.createElement("div", {
                      className: "flex flex-col items-center sm:items-start pr-6"
                    }, React.createElement("div", {
                          className: "pt-6 sm:pt-0 order-2 sm:order-1"
                        }, React.createElement(Tooltip, {
                              title: "Click to see more info.",
                              children: React.createElement("div", {
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(onShowPlayerRadarInfo, undefined);
                                      })
                                  }, React.createElement(PlRadar.make, {
                                        matches: matches,
                                        width: 220
                                      }))
                            })), React.createElement("div", {
                          className: "order-1 sm:order-2 pt-[6px] sm:pt-[18px]"
                        }, React.createElement(PlStatsTab$MostPlayed, {
                              matches: matches
                            }))), React.createElement("div", {
                      className: "flex flex-col items-center sm:items-end pt-6 sm:pt-0 sm:ml-[-24px]"
                    }, React.createElement(PlStats.make, {
                          matches: matches,
                          flexibility: flexibility,
                          isDuo: filter.typ === /* Duo */4
                        }), React.createElement("div", {
                          className: "pt-6"
                        }, React.createElement(PlPlacesDistribution.make, {
                              matches: matches,
                              chartHeight: 205,
                              barArea: barArea
                            })))));
}

var make = PlStatsTab;

export {
  MostPlayed ,
  make ,
  
}
/* Sd Not a pure module */
